import { notification } from 'antd'
import axios from './axiosInstance'
import constants from '../constants'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('subscriptions init')
}

export async function subscribe(post, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error
      })
  }
  return false
}

export async function unsubscribe(app, userDataObj = false) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .delete(`${ACTION_URL}apps/${app.id}/subscriptions`, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        if (userDataObj && userDataObj !== '') {
          localStorage.setItem('userData', userDataObj)
        }
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function stripeCall1(post, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function stripeCall2(post, app, userDataObj = false) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        if (userDataObj && userDataObj !== '') {
          localStorage.setItem('userData', userDataObj)
        }
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}
